import { IElement } from '../Element';
import { code, uri } from '../Primitives';

export const isCodingEqual = (a?: ICoding, b?: ICoding) =>
  !!a && !!b && a.system === b.system && a.code === b.code;
export const isCodingEqualByCode = (a: ICoding | undefined, code: string) =>
  !!a && a.code === code;
export interface ICoding extends IElement {
  system?: uri;
  version?: string;
  code?: code;
  display?: string;
  userSelected?: boolean;
}
